import React from "react";
import { Link, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const Account = () => {
  const user = useSelector((state) => state.user.user);

  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="container mx-auto px-4 flex gap-6">

        {/* Sidebar */}
        <div className="w-64 bg-white rounded shadow p-4">

          <div className="mb-6">
            <h2 className="font-semibold text-lg">{user?.name}</h2>
            <p className="text-sm text-gray-500">{user?.email}</p>
          </div>

          <nav className="flex flex-col gap-3 text-sm">

            <Link to="profile" className="hover:text-red-600">
              My Profile
            </Link>

            <Link to="orders" className="hover:text-red-600">
              My Orders
            </Link>

            <Link to="address" className="hover:text-red-600">
              Address
            </Link>

            <Link to="wallet" className="hover:text-red-600">
              Wallet
            </Link>

            <Link to="help" className="hover:text-red-600">
              Help Center
            </Link>

            {user?.role === "ADMIN" && (
              <Link
                to="/dashboard"
                className="text-blue-600 font-medium"
              >
                Admin Panel
              </Link>
            )}

          </nav>
        </div>

        {/* Content */}
        <div className="flex-1 bg-white rounded shadow p-6">
          <Outlet />
        </div>

      </div>
    </div>
  );
};

export default Account;